import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { PERMISSION } from '../constants';
import ProtectedRoute from './ProtectedRoute';
import AgencySchedule from '../features/external-agency/schedule/AgencySchedule';
import AgencyProfessionals from '../features/external-agency/professionals/AgencyProfessionals';
import AgencyProfessionalsDetails from '../features/external-agency/professionals/AgencyProfessionalsDetails';
import AgencyContacts from '../features/external-agency/contacts/AgencyContacts';
import AgencyProfessionalsCreate from '../features/external-agency/professionals/AgencyProfessionalsCreate';

/* eslint-disable-next-line no-unused-vars */
const AgencyRoutes = ({ userData }) => {
	return (
		<Switch>
			<Route path="/private/agency/shifts" exact component={AgencySchedule} />
			<Route path="/private/agency/professionals" exact component={AgencyProfessionals} />
			<Route path="/private/agency/professionals/create" component={AgencyProfessionalsCreate} />
			<Route path="/private/agency/professionals/:caregiverId" component={AgencyProfessionalsDetails} />
			<ProtectedRoute
				path="/private/agency/contacts"
				exact
				pathPermission={PERMISSION.AGENCY.CONTACTS_VIEW}
				userPermissions={userData.permissions}
				component={AgencyContacts}
			/>
			<Route path="/" render={() => <Redirect to="/404" />} />
		</Switch>
	);
};

export default AgencyRoutes;
